import React, { Component } from "react";
import { Redirect } from "react-router-dom";
import { connect } from "react-redux";

import Spinner from "../../assets/images/oval.svg";
import { clientName } from "../../../config/config";
import { login } from "../../store/auth/services";
import {
  Button,
  Alert,
  Form,
  Col,
  FormGroup,
  Label,
  Input,
  Container,
  Card,
  CardBody
} from "reactstrap";

import "./login.css";

import Logo from "../../assets/images/nucleus-icon.svg";

class Login extends Component {
  static displayName = "Login Page";

  constructor(props) {
    super(props);

    this.state = {
      email: "",
      password: "",
      error: ""
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleChange(name, value) {
    this.setState({ [name]: value });
  }

  handleSubmit(e) {
    e.preventDefault();
    const { email, password } = this.state;
    this.props.dispatch(login({ email, password }));
  }

  render() {
    if (this.props.isAuthenticated) {
      return <Redirect to="/dashboard" />;
    }

    return (
      <section className="login-container">
        <Container>
          <Col sm={10} md={6} lg={4} xl={4}>
            <div className="logo-wrapper">
              <img src={Logo} className="logo" alt="Logo" />
              <div className="client-name">{clientName}</div>
            </div>
            <Card>
              <CardBody>
                <Form onSubmit={this.handleSubmit}>
                  <FormGroup>
                    <Label htmlFor="email">E-Mail Address</Label>
                    <Input
                      placeholder="Email Address"
                      type="email"
                      name="email"
                      autoFocus
                      onChange={e =>
                        this.handleChange(e.target.name, e.target.value)
                      }
                    />
                  </FormGroup>

                  <FormGroup>
                    <Label htmlFor="password">Password</Label>
                    <Input
                      placeholder="Password"
                      type="password"
                      name="password"
                      onChange={e =>
                        this.handleChange(e.target.name, e.target.value)
                      }
                    />
                  </FormGroup>
                  <FormGroup>
                    <Button color="primary" type="submit" size="lg" block>
                      {this.props.loading && (
                        <img src={Spinner} width="20" alt="Spinner" />
                      )}
                      {!this.props.loading && <span>Login</span>}
                    </Button>
                  </FormGroup>
                  {this.props.error ? (
                    <FormGroup>
                      <Alert color="danger">{this.props.error}</Alert>
                    </FormGroup>
                  ) : (
                    ""
                  )}
                </Form>
              </CardBody>
            </Card>
          </Col>
        </Container>
      </section>
    );
  }
}

function mapStateToProps(store) {
  return {
    isAuthenticated: store.auth.isAuthenticated,
    error: store.auth.error,
    loading: store.auth.isLoading
  };
}

export default connect(mapStateToProps)(Login);



// WEBPACK FOOTER //
// ./src/system/containers/Login/index.jsx